import React from 'react'

const BREAKPOINTS = {
    small: 767,
    medium: 1024,
    large: 1441
}

const calculateBreakpoint = () => {
    const width = window.innerWidth

    if (width < BREAKPOINTS.small) {
        return 0
    }
    if (width < BREAKPOINTS.medium) {
        return 1
    }
    if (width < BREAKPOINTS.large) {
        return 2
    }
    return 3
}

const useBreakpoint = () => {
    const [activeBreakpoint, setActiveBreakpoint] = React.useState(calculateBreakpoint())

    React.useEffect(() => {
        const listener = () => {
            const newBreakpoint = calculateBreakpoint()
            if (newBreakpoint !== activeBreakpoint) {
                setActiveBreakpoint(newBreakpoint)
            }
        }
        window.addEventListener('resize', listener)
        return () => window.removeEventListener('resize', listener)
    }, [activeBreakpoint])

    return activeBreakpoint
}

export default useBreakpoint
